import { ShareLinkActions } from "slot-definitions"
import { DownloadTasksAsExcelSpreadsheet } from "routes/regime/plugins/download-tasks/download-tasks-as-excel-spreadsheet"
import { Feature, isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_DOWNLOAD_TASKS } from "routes/asset-register/feature_flag_download_tasks"
import { DataExportTypes } from "event-definitions"
import { registerFeatureWithDescription } from "lib/features"
import { CATEGORY_SCHEDULE_LIBRARY } from "lib/feature-category"
import { FEATURE_FLAG_MAINTENANCE_EXPORT_ASSET_NUMBERS } from "./server/feature-flag-maintenance-export-asset-numbers.mjs"

// Registered here because the numerical id guard only scans .runtime.js files
registerFeatureWithDescription({
    numericalId: 411,
    id: FEATURE_FLAG_MAINTENANCE_EXPORT_ASSET_NUMBERS,
    name: "Maintenance Export Asset Numbers",
    // Without it the 400 range files the flag under Authoring & Content
    category: CATEGORY_SCHEDULE_LIBRARY,
    internalUseOnly: true,
    descriptionLines: [
        "Adds an Asset Number column to the Tasks sheet of the share link Excel export and repeats each task row once per linked asset.",
        "Linked assets with no task to repeat are listed on an Assets Without Tasks sheet.",
        "Asset numbers match the asset register export.",
        "Ticking this only allows the feature. To enable it for a client, also attach an auth bundle holding the feature demand.",
    ],
})

ShareLinkActions.plug(
    <Feature feature={FEATURE_FLAG_DOWNLOAD_TASKS} priority={50}>
        <DownloadTasksAsExcelSpreadsheet />
    </Feature>
)

DataExportTypes.handle(({ exportTypes }) => {
    if (isEnabled(FEATURE_FLAG_DOWNLOAD_TASKS)) {
        exportTypes.push({
            label: "Excel",
            shareLinkProperty: "canDownloadExcel",
            description: "Allows a download in Excel (xls) format of data shared. Cells include summaries steps",
        })
    }
})
